<template>
    <div>
        <div class="modal-overlay active" @click="closeDialog()"></div>
        <div class="modal">
            <div class="modal__header">
                <h2 id="emailModalTitle" class="headline-s">Delete User</h2>
                <CloseIcon @click="closeDialog()" class="modal__header--close" alt="Close Modal" aria-label="Close" />
            </div>
            <div id="emailModalBody" class="modal__body flex-column">
                <p class="paragraph-default">Are you sure you want to delete user {{ user.username }}</p>
                <RothcoCta id="submitButton" class="primary" @click="submit">Delete User</RothcoCta>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import {  computed, inject, } from "vue";
    import RothcoCta from "@/components/RothcoCta.vue";
    import CloseIcon from "@icons/closeIcon.svg";
    
    const dialogRef = inject('dialogRef');

    const closeDialog = () => {
        dialogRef?.value?.close({ deleteUser: false});
    }
    const user = computed(() => {
        return dialogRef?.value?.data?.user ?? null;
    }); 
    const submit = function () {
        dialogRef?.value?.close({ deleteUser: true, })
    };
</script>
